import Money from '@/common/models/money'
import type { InstrumentPrices } from '@/common/types'

// Utility for trading logic
export function getMinShares(
    orderAction: string | undefined,
    sharesCurrentlyHeld: number | undefined,
    price: number,
): number {
    if (!price || price <= 0) {
        return 0
    }
    if (orderAction === 'SELL') {
        return sharesCurrentlyHeld ?? 0
    }

    if (!sharesCurrentlyHeld || sharesCurrentlyHeld === 0) {
        return Math.ceil(500 / price)
    }

    return 1
}

export const getLastPrice = (priceInfo: InstrumentPrices): number =>
    priceInfo?.lastPrice ?? priceInfo?.closingPrice ?? priceInfo?.buyPrice ?? 0

export const getInvestmentAmount = (minShares: number, price: number): Money => Money.of(minShares * price * 1.02)
